import React, { useState } from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import TravelTutorSection from '../components/TravelTutorSection';
import EliteAthletesSection from '../components/EliteAthletesSection';
import TrustBadgesBar from '../components/TrustBadgesBar';
import SocialProofSection from '../components/SocialProofSection';
import AboutSection from '../components/AboutSection';
import ServicesSection from '../components/ServicesSection';
import FreeTrialSection from '../components/FreeTrialSection';
import TimetableSection from '../components/TimetableSection';
import EliteTutoringSection from '../components/EliteTutoringSection';
import GoFundMeSection from '../components/GoFundMeSection';
import TopicsSection from '../components/TopicsSection';
import GradeCalculator from '../components/GradeCalculator';
import MathsChallengeSection from '../components/MathsChallengeSection';
import VideoLessonsSection from '../components/VideoLessonsSection';
import PricingSection from '../components/PricingSection';
import ReferralTracker from '../components/ReferralTracker';
import TestimonialsSection from '../components/TestimonialsSection';
import FAQSection from '../components/FAQSection';
import NewsletterSignup from '../components/NewsletterSignup';
import VacancySection from '../components/VacancySection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';
import FloatingBookButton from '../components/FloatingBookButton';
import ExitIntentPopup from '../components/ExitIntentPopup';
import WhatsAppButton from '../components/WhatsAppButton';

const HomePage = () => {
  return (
    <div style={{ background: 'var(--bg-page)' }}>
      <Header />
      <HeroSection />
      <TravelTutorSection />
      <EliteAthletesSection />
      <TrustBadgesBar />
      <SocialProofSection />
      <AboutSection />
      <FreeTrialSection />
      <ServicesSection />
      <TimetableSection />
      <GradeCalculator />
      <MathsChallengeSection />
      <EliteTutoringSection />
      <GoFundMeSection />
      <TopicsSection />
      <VideoLessonsSection />
      <PricingSection />
      <ReferralTracker />
      <TestimonialsSection />
      <FAQSection />
      <NewsletterSignup />
      <ContactSection />
      <VacancySection />
      <Footer />
      <FloatingBookButton />
      <WhatsAppButton />
      <ExitIntentPopup />
    </div>
  );
};

export default HomePage;
